import React from "react";

const NumberReservationsNormalization = ({ row }) => {
  return (
    <div>
      {row?.reservationsNumber ? row?.reservationsNumber?.toLocaleString() : 0}
    </div>
  );
};

export default NumberReservationsNormalization;
